import { useEffect, useState } from "react";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { _RequestMaintenance, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { SelectTechnicians } from "../../../../../Factoty&Production/Maintenance/Technicians/SelectTechnicians";
import { toast } from "react-toastify";

interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}


interface Props {
    configProcedure: ProcedureFunctions;
}

export const MD002 = ({ configProcedure }: Props) => {

    const { instance, bean, setBean } = useDataBean(_RequestMaintenance);
    const [props, setProps] = useState<any>({});
    const [request, setRequest] = useState<any>({});

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
    }, [configProcedure?._pocessData])

    useEffect(() => {
        instance.getRequestMaintenanceCatalogPorPropiedades({ IDProceudreIMP: props.IDProceudreIMP }, null).then(
            (resp) => {
                if (resp?.length > 0 && resp[0].DataBeanProperties) {
                    setRequest(resp[0].DataBeanProperties);
                }
            }
        ).catch(
            err => { console.log("No se pudo cargar la informacion") }
        )
    }, [props])

    const onExportMap = (obj?: any) => {

        instance.updateRequestMaintenance({
            ...request,
            State: 2,
            IDTechnicians: bean.IDTechnicians,
            IDTechnicianName: `${bean.TechnicianNit} - ${bean.TechnicianName}`,
            CodeTechnician: bean.CodeTechnician,
        }).then(
            (resp) => {
                if (configProcedure?._pushInfo) {
                    configProcedure?._pushInfo(`Se asigno al tenico ${bean.CodeTechnician} - ${bean.TechnicianName}`);
                }
                if (configProcedure?._exportMap) {
                    configProcedure?._exportMap(bean);
                }
                if (configProcedure?._pushProps) {
                    configProcedure?._pushProps({ IDTechnicians: bean.IDTechnicians });
                }
            }
        ).catch(
            err => { toast.error("No se pudo realizar la accion") }
        );

    };


    return (
        <div className="row">
            <div className="col-md-12">
                <SelectTechnicians idSelector={bean.IDTechnicians} onChange={(e) => { setBean({ ...e }) }} returnType="Object" label="Asignar Tecnico a Cargo" />
            </div>
            <div className="col-md-12 mt-4">
                <BasicButton eventClick={onExportMap} icon="ri-user-add-line" children={`Asignar Tecnico`} />
            </div>
        </div>
    )
}